module.exports = __webpack_public_path__ + "img/vegetable-nopales-190x100.c1319ba6.jpg";